module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Border-800494d289ff6038c0e5227cff15ac5b.svg";